export default "__VITE_ASSET__DRRpGTTb__"